<div class="modal-header">
    <h3 class="modal-title">{{ modalTitle }}</h3>
    <div class="header-actions">
        <i class="fa" 
           [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
           style="margin-right: 10px; cursor: pointer;" 
           (click)="minimise=!minimise"></i>
        <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
    </div>
</div>

<div class="modal-body" [hidden]="minimise">
    @if (showEntityLoader) {
<div class="formLoader">
        <i class="fa fa-spinner fa-spin gt-refresh"></i>
    </div>
}
    
    @if (!showEntityLoader) {
<div>
        <!-- Filing Dates Setup Section -->
        <div class="panel panel-default">
            <div class="panel-heading">
                <h4><b>Filing Dates Setup:</b></h4>
            </div>
            <div class="panel-body">
                <!-- Create Mode Layout -->
                @if (!isUpdateMode) {
<div>
                    <!-- Row 1: Tax Year, Scenario Type Code, Scenario Desc -->
                    <div class="row">
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="tax-year"><b>Tax Year<sup>*</sup>:</b></label>
                                <input type="text" class="form-control" 
                                    id="tax-year" name="tax-year" placeholder=""
                                    [(ngModel)]="entityFiling.TAX_YEAR" readonly>
                            </div>
                            @if (entityFiling.TAX_YEAR_NOT_VALID && !entityFiling.TAX_YEAR) {
<small class="text-danger" 
                               >
                                Please provide Tax Year
                            </small>
}
                        </div>
                        
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="scenario-type-code"><b>Scenario Type Code<sup>*</sup>:</b></label>
                                <select class="form-control" id="scenario-type-code" name="scenario-type-code" 
                                    [(ngModel)]="entityFiling.SCENARIO_TYPE_CODE" (ngModelChange)="onScenarioTypeCodeChange()">
                                    <option value="">Select Scenario Type Code</option>
                                    @for (scenarioTypeCode of allscenarioTypeCode; track $index; let i = $index) {
<option 
                                        [value]="scenarioTypeCode.SCENARIO_TYPE_CODE">{{scenarioTypeCode.SCENARIO_TYPE_CODE}}</option>
}
                                </select>
                            </div>
                            @if (entityFiling.SCENARIO_TYPE_CODE_NOT_VALID && !entityFiling.SCENARIO_TYPE_CODE) {
<small class="text-danger">Please provide Scenario Type Code</small>
}
                        </div>
                        
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="scenario-desc"><b>Scenario Desc<sup>*</sup>:</b></label>
                                <select class="form-control" id="scenario-desc" name="scenario-desc" 
                                    [(ngModel)]="entityFiling.SCENARIO_DESC" (ngModelChange)="onPopulateGroupObjYear()">
                                    <option value="">Select Scenario Description</option>
                                    @for (scenarioDesc of allscenarioDesc; track $index; let i = $index) {
<option 
                                        [value]="scenarioDesc.SCENARIO_VALUE">{{scenarioDesc.SCENARIO_DESC}}</option>
}
                                </select>
                            </div>
                            @if (entityFiling.SCENARIO_DESC_NOT_VALID && !entityFiling.SCENARIO_DESC) {
<small class="text-danger">Please provide Scenario Desc</small>
}
                        </div>
                    </div>
                    
                    <!-- Row 2: Group Object Key, Legal Entity ID, Filing Cycle -->
                    <div class="row">
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="gok"><b>Group Object Key<sup>*</sup>:</b></label>
                                <select class="form-control" id="gok" name="gok" 
                                    [(ngModel)]="entityFiling.GROUP_OBJ_KEY" (ngModelChange)="onPopulateFilingLEID()">
                                    <option value="">Select Group Object Key</option>
                                    @for (groupObjByYear of allGroupObjByYear; track $index; let i = $index) {
<option 
                                        [value]="groupObjByYear.GROUP_OBJ_KEY">{{groupObjByYear.GROUP_OBJ_KEY}}</option>
}
                                </select>
                                @if (entityFiling.GROUP_OBJ_KEY_NOT_VALID && !entityFiling.GROUP_OBJ_KEY) {
<small class="text-danger">
                                    Please provide Group Object Key
                                </small>
}
                            </div>
                        </div>
                        
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="filling-entity-id"><b>Legal Entity ID<sup>*</sup>:</b></label>
                                <input list="legalEntityIdList" class="form-control" 
                                    id="filling-entity-id-create" name="filling-entity-id" 
                                    [(ngModel)]="entityFiling.LEGAL_ENTITY_ID"
                                    placeholder="Select Entity" required/>
                                <datalist id="legalEntityIdList" >
                                    @for (leid of allLeids; track $index; let i = $index) {
<option 
                                        [value]="leid.LEGAL_ENTITY_ID">{{leid.LEGAL_ENTITY_ID}}</option>
}
                                </datalist>
                                @if (entityFiling.LEGAL_ENTITY_ID_NOT_VALID && !entityFiling.LEGAL_ENTITY_ID) {
<small class="text-danger">Please provide Filing Legal Entity Id</small>
}
                            </div>
                        </div>
                        
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="FilingCycleType"><b>Filing Cycle<sup>*</sup>:</b></label>
                                <input list="filingCycleTypeList" class="form-control" 
                                    id="filling-cycle-type" name="filling-cycle-type" 
                                    [(ngModel)]="entityFiling.FILING_CYCLE"
                                    (ngModelChange)="upper(entityFiling.FILING_CYCLE)"
                                    (blur)="onPopulateTaxDate()"
                                    placeholder="Select Filing Cycle" required/>
                                <datalist id="filingCycleTypeList" >
                                    @for (filingCycleType of allFilingCycleTypes; track $index; let i = $index) {
<option 
                                        [value]="filingCycleType.FILING_CYCLE">{{filingCycleType.FILING_CYCLE}}</option>
}
                                </datalist>
                                @if (entityFiling.FILING_CYCLE_NOT_VALID && !entityFiling.FILING_CYCLE) {
<small class="text-danger">Please provide Filing Cycle</small>
}
                            </div>
                        </div>
                    </div>
                </div>
}
                
                <!-- Update Mode Layout: Single row with 4 fields -->
                @if (isUpdateMode) {
<div class="row">
                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="tax-year"><b>Tax Year<sup>*</sup>:</b></label>
                            <input type="text" class="form-control" 
                                id="tax-year" name="tax-year" placeholder=""
                                [(ngModel)]="entityFiling.TAX_YEAR" readonly>
                        </div>
                        @if (entityFiling.TAX_YEAR_NOT_VALID && !entityFiling.TAX_YEAR) {
<small class="text-danger" 
                           >
                            Please provide Tax Year
                        </small>
}
                    </div>
                    
                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="gok"><b>Group Object Key<sup>*</sup>:</b></label>
                            <input type="text" class="form-control" 
                                id="gok" name="gok" placeholder=""
                                [(ngModel)]="entityFiling.GROUP_OBJ_KEY" readonly>
                            @if (entityFiling.GROUP_OBJ_KEY_NOT_VALID && !entityFiling.GROUP_OBJ_KEY) {
<small class="text-danger">
                                Please provide Group Object Key
                            </small>
}
                        </div>
                    </div>
                    
                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="filling-entity-id"><b>Legal Entity ID<sup>*</sup>:</b></label>
                            <input type="text" class="form-control" 
                                id="filling-entity-id" name="filling-entity-id" 
                                [(ngModel)]="entityFiling.LEGAL_ENTITY_ID"
                                readonly/>
                            @if (entityFiling.LEGAL_ENTITY_ID_NOT_VALID && !entityFiling.LEGAL_ENTITY_ID) {
<small class="text-danger">Please provide Filing Legal Entity Id</small>
}
                        </div>
                    </div>
                    
                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="scenario-app"><b>Scenario<sup>*</sup>:</b></label>
                            <input type="text" class="form-control" 
                                id="scenario-app" name="scenario-app" 
                                [(ngModel)]="entityFiling.SCENARIO"
                                readonly/>
                        </div>
                    </div>
                </div>
}
            </div>    
        </div>    
        
        <!-- Filing Dates Details Section -->
        <div class="panel panel-default">
            <div class="panel-heading">
                <h4><b>Filing Dates Details:</b></h4>
            </div>
            <div class="panel-body">
                <!-- Create Mode Layout -->
                @if (!isUpdateMode) {
<div class="row">
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="scenario-details"><b>Scenario<sup>*</sup>:</b></label>
                            <input list="appScenariosList" class="form-control" 
                                id="scenario-details" name="scenario-details" 
                                [(ngModel)]="entityFiling.SCENARIO"
                                placeholder="Select Scenario" required/>
                            <datalist id="appScenariosList" >
                                @for (appScenario of allAppScenarios; track $index; let i = $index) {
<option 
                                    [value]="appScenario.SCENARIO">{{appScenario.SCENARIO}}</option>
}
                            </datalist>
                            @if (entityFiling.SCENARIO_NOT_VALID && !entityFiling.SCENARIO) {
<small class="text-danger">Please provide Scenario</small>
}
                        </div>
                    </div>
                    
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="taxYearBegin"><b>Tax Year Begin<sup>*</sup>:</b></label>
                            <input type="date" class="form-control" 
                                id="taxYearBegin"
                                [(ngModel)]="entityFiling.TAX_YEAR_BEGIN"
                                (change)="onTaxYearBeginChange()"
                                [min]="minYear"
                                [max]="maxYear"
                                placeholder="MM/DD/YYYY"/>
                            @if (entityFiling.TAX_YEAR_BEGIN_NOT_VALID && !entityFiling.TAX_YEAR_BEGIN) {
<small class="text-danger">
                                Please provide Tax Year Begin date</small>
}
                        </div>
                    </div>
                    
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="taxYearEnd"><b>Tax Year End<sup>*</sup>:</b></label>
                            <input type="date" class="form-control" 
                                id="taxYearEnd"
                                [(ngModel)]="entityFiling.TAX_YEAR_END"
                                (change)="onTaxYearEndChange()"
                                [min]="minYear"
                                [max]="maxYear"
                                placeholder="MM/DD/YYYY"/>
                            @if (entityFiling.TAX_YEAR_END_NOT_VALID && !entityFiling.TAX_YEAR_END) {
<small class="text-danger">
                                Please provide Tax Year End date</small>
}
                        </div>
                    </div>
                </div>
}
                
                <!-- Update Mode Layout (unchanged) -->
                @if (isUpdateMode) {
<div class="row">
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="FilingCycleType"><b>Filing Cycle<sup>*</sup>:</b></label>
                            <input list="filingCycleTypeList" class="form-control" 
                                id="filling-cycle-type" name="filling-cycle-type" 
                                [(ngModel)]="entityFiling.FILING_CYCLE"
                                (ngModelChange)="upper(entityFiling.FILING_CYCLE)"
                                (blur)="onPopulateTaxDate()"
                                placeholder="Select Filing Cycle" required/>
                            <datalist id="filingCycleTypeList" >
                                @for (filingCycleType of allFilingCycleTypes; track $index; let i = $index) {
<option 
                                    [value]="filingCycleType.FILING_CYCLE">{{filingCycleType.FILING_CYCLE}}</option>
}
                            </datalist>
                            @if (entityFiling.FILING_CYCLE_NOT_VALID && !entityFiling.FILING_CYCLE) {
<small class="text-danger">Please provide Filing Cycle</small>
}
                        </div>
                    </div>
                    
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="taxYearBegin"><b>Tax Year Begin<sup>*</sup>:</b></label>
                            <input type="date" class="form-control" 
                                id="taxYearBegin"
                                [(ngModel)]="entityFiling.TAX_YEAR_BEGIN"
                                (change)="onTaxYearBeginChange()"
                                [min]="minYear"
                                [max]="maxYear"
                                placeholder="MM/DD/YYYY"/>
                            @if (entityFiling.TAX_YEAR_BEGIN_NOT_VALID && !entityFiling.TAX_YEAR_BEGIN) {
<small class="text-danger">
                                Please provide Tax Year Begin date</small>
}
                        </div>
                    </div>
                    
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="taxYearEnd"><b>Tax Year End<sup>*</sup>:</b></label>
                            <input type="date" class="form-control" 
                                id="taxYearEnd"
                                [(ngModel)]="entityFiling.TAX_YEAR_END"
                                (change)="onTaxYearEndChange()"
                                [min]="minYear"
                                [max]="maxYear"
                                placeholder="MM/DD/YYYY"/>
                            @if (entityFiling.TAX_YEAR_END_NOT_VALID && !entityFiling.TAX_YEAR_END) {
<small class="text-danger">
                                Please provide Tax Year End date</small>
}
                        </div>
                    </div>
                </div>
}
                
                <!-- Row 2: Active and Roll Forward (Create Mode) -->
                @if (!isUpdateMode) {
<div class="row">
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="active-y-n"><b>Active<sup>*</sup>:</b></label>
                            <select class="form-control" id="active-y-n" name="active-y-n" 
                                [(ngModel)]="entityFiling.ACTIVE_Y_N">
                                <option value="Y" selected>Y</option>
                                <option value="N">N</option>
                            </select>
                            @if (entityFiling.ACTIVE_Y_N_NOT_VALID && !entityFiling.ACTIVE_Y_N) {
<small class="text-danger">Please provide Active</small>
}
                        </div>
                    </div>
                    
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="rollfwd-y-n"><b>Roll Forward<sup>*</sup>:</b></label>
                            <select class="form-control" id="rollfwd-y-n" name="rollfwd-y-n" 
                                [(ngModel)]="entityFiling.ROLLFWD_Y_N">
                                <option value="Y" selected>Y</option>
                                <option value="N">N</option>
                            </select>
                            @if (entityFiling.ROLLFWD_Y_N_NOT_VALID && !entityFiling.ROLLFWD_Y_N) {
<small class="text-danger">Please provide RollForward</small>
}
                        </div>
                    </div>
                    
                    <!-- Empty third column for create mode layout -->
                    <div class="col-md-4"></div>
                </div>
}
                
                <!-- Row 2: Active and Roll Forward (Update Mode) -->
                @if (isUpdateMode) {
<div class="row">
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="active-y-n"><b>Active<sup>*</sup>:</b></label>
                            <select class="form-control" id="active-y-n" name="active-y-n" 
                                [(ngModel)]="entityFiling.ACTIVE_Y_N">
                                <option value="Y" selected>Y</option>
                                <option value="N">N</option>
                            </select>
                            @if (entityFiling.ACTIVE_Y_N_NOT_VALID && !entityFiling.ACTIVE_Y_N) {
<small class="text-danger">Please provide Active</small>
}
                        </div>
                    </div>
                    
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="rollfwd-y-n"><b>Roll Forward<sup>*</sup>:</b></label>
                            <select class="form-control" id="rollfwd-y-n" name="rollfwd-y-n" 
                                [(ngModel)]="entityFiling.ROLLFWD_Y_N">
                                <option value="Y" selected>Y</option>
                                <option value="N">N</option>
                            </select>
                            @if (entityFiling.ROLLFWD_Y_N_NOT_VALID && !entityFiling.ROLLFWD_Y_N) {
<small class="text-danger">Please provide RollForward</small>
}
                        </div>
                    </div>
                    
                    <!-- Empty third column for update mode layout -->
                    <div class="col-md-4"></div>
                </div>
}
            </div>
        </div>
    </div>
}
</div>

<div class="modal-footer" [hidden]="minimise">
    <button class="save-button" type="button" (click)="save()" 
            [disabled]="crudLoading || isSavingUpdate || isSavingRemove || isSavingDelete">
        {{isUpdateMode ? 'Update' : 'Create'}}
        @if (crudLoading || isSavingUpdate) {
<span>
            <i class="fa fa-spinner fa-pulse"></i>
        </span>
}
    </button>
    
    @if (isUpdateMode) {
<button class="remove-button" type="button" (click)="removeEntityFiling()" 
            [disabled]="crudLoading || isSavingUpdate || isSavingRemove || isSavingDelete">
        Remove
        @if (isSavingRemove) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}
    </button>
}
    
    <button class="reset-button" type="button" (click)="reset()">Reset</button>
    
    <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
    
    @if (isUpdateMode) {
<button class="delete-button" type="button" (click)="deleteEntityFiling()" 
            [disabled]="crudLoading || isSavingUpdate || isSavingRemove || isSavingDelete">
        Delete
        @if (isSavingDelete) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}
    </button>
}
</div>
